import { render, staticRenderFns } from "./FileDrop.vue?vue&type=template&id=1dd7fafc&scoped=true&"
import script from "./FileDrop.vue?vue&type=script&lang=ts&"
export * from "./FileDrop.vue?vue&type=script&lang=ts&"
import style0 from "./FileDrop.vue?vue&type=style&index=0&id=1dd7fafc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dd7fafc",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSheet } from 'vuetify/lib/components/VSheet';
installComponents(component, {VIcon,VRow,VSheet})
